// Async bootstrap — вызывается в main.tsx ДО ReactDOM.render.
// Решает: показывать ли cookie banner и грузить ли Yandex.Metrika.

import { loadYandexMetrika } from '@/lib/yandexMetrika';
import { useConsentStore } from './consentStore';
import { isGPCEnabled } from './gpc';

export async function bootstrapConsent(): Promise<void> {
  // 1. GPC signal — auto-reject (override любого stored consent)
  if (isGPCEnabled()) {
    await useConsentStore.getState().rejectAll('gpc_signal');
    return;
  }

  // 2. Hydrate из localStorage
  useConsentStore.getState().hydrateFromStorage();

  // 3. Если consent есть и analytics включён — грузим Metrika
  const { hasConsent, choices } = useConsentStore.getState();
  if (hasConsent && choices?.analytics) {
    loadYandexMetrika();
  }

  // 4. Если consent нет — показываем banner
  if (!hasConsent) {
    useConsentStore.getState().showBanner();
  }
}
